import React from 'react';
import { connect } from 'react-redux';
import './App.scss';

import MessengerCustomerChat from 'react-messenger-customer-chat';

// Common screens
import LoginScreen from './components/Login/LoginScreen'
import Menu from './components/Menu/Menu'
import PopupContainer from './components/Popup/PopupContainer'

// Pro Screens
import ProSettingsScreen from './components/Pro/ProSettingsScreen'
import ProParrainageScreen from './components/Pro/ProParrainageScreen'
import ProAdsScreen from './components/Pro/ProAdsScreen'
import ProPartnersScreen from './components/Pro/ProPartnersScreen'
import AssoPartnersScreen from './components/Pro/AssoPartnersScreen'
import AssoContactScreen from './components/Pro/AssoContactScreen'
import ProPayoutsScreen from './components/Pro/ProPayoutsScreen'
import ProSetupSuccess from './components/Pro/ProSetupSuccess'

import TicketingTicketScreen from './components/Ticketing/TicketingTicketScreen'
import TicketingPromoScreen from './components/Ticketing/TicketingPromoScreen'

import AdminsScreen from './components/Admin/Admins/AdminsScreen'
import AdminScreen from './components/Admin/Admins/AdminScreen'

import AdsScreen from './components/Admin/Ads/AdsScreen'
import CategoryScreen from './components/Admin/Ads/CategoryScreen'

import AdScreen from './components/Admin/Ads/AdScreen'
import ScanScreen from './components/Pro/ScanScreen'

import PayoutsScreen from './components/Admin/Payouts/PayoutsScreen'
import GamesScreen from './components/Admin/Games/GamesScreen'
import GameScreen from './components/Admin/Games/GameScreen'

import ProsScreen from './components/Admin/Pros/ProsScreen'
import ProScreen from './components/Admin/Pros/ProScreen'

import NotifsScreen from './components/Admin/Notifs/NotifsScreen'
import NotifScreen from './components/Admin/Notifs/NotifScreen'

import PartnersScreen from './components/Admin/Partners/PartnersScreen'
import PartnerScreen from './components/Admin/Partners/PartnerScreen'

import MapScreen from './components/Admin/Map/MapScreen'
import StatsScreen from './components/Admin/Stats/StatsScreen'
import TestAccountsScreen from './components/Admin/TestAccounts/TestAccountsScreen'

import { BrowserRouter as Router, Route } from 'react-router-dom'
import { Fire } from './services'
import { autologin, finishLogin } from './actions/auth.action'

interface Props {
  user: any;

  autologin: (user: any) => void;
  finishLogin: () => void;
}
interface State {
  booted: boolean;
}
class Routing extends React.Component<Props, State> {
  
  state = {
    booted: false,
  }

  componentDidMount() {
    /*const preventDefault = e => e.preventDefault();
    window.addEventListener('touchmove', preventDefault, {
       passive: false
    });*/
    
    //Fire.auth().signOut()
    Fire.auth().onAuthStateChanged(async (user: any) => {
      await this.props.autologin(user)
      if (user)
        await this.props.finishLogin()

      if (!this.state.booted)
        this.setState({ booted: true })
    });
  }

  render() {
    if (!this.state.booted)
      return (null)

    const { user } = this.props
    return (
      <Router>
        { !user ? (
          <div className="main-wrapper">
            <LoginScreen />
          </div>
        ) : (
          <div>
            <Menu />

            { /* SHARED ROUTES **/ }
            <Route component={AdScreen} path='/ads/:type/:id' exact />
            <Route component={AdScreen} path='/ads/:type/:id/:tab' exact />
            <Route component={ScanScreen} path='/scan' exact />
            
            <Route component={TicketingTicketScreen} path='/ticketing/:elementId/ticket/:ticketId' exact />
            <Route component={TicketingPromoScreen} path='/ticketing/:elementId/promo/:promoId' exact />
            
            <Route component={ProSetupSuccess} path='/stripe_setup/:status' exact />

            { !user.admin ? (
              <React.Fragment>
                {/* PRO ROUTES EVENTS */}
                <Route component={ProSettingsScreen} path='/(settings|)' exact />
                <Route component={ProParrainageScreen} path='/parrainage' exact />
                <Route component={ProAdsScreen} path='/app' exact />
                <Route component={ProAdsScreen} path='/app/:tab' exact />
                { user.type === 'asso' && (
                  <>
                    <Route component={AssoPartnersScreen} path='/partners' exact />
                    <Route component={AssoPartnersScreen} path='/partners/:tab' exact />
                    <Route component={AssoContactScreen} path='/contact/:proId' exact />
                  </>
                )}
                <Route component={ProPayoutsScreen} path='/payouts' exact />
              </React.Fragment>
            ) : (
              <React.Fragment>
                {/* ADMIN ROUTES */}
                <Route component={AdsScreen} path='/(app|)' exact />
                <Route component={AdsScreen} path='/app/:tab' exact />
                
                <Route component={PayoutsScreen} path='/admin/payouts' exact/>
                <Route component={PayoutsScreen} path='/admin/payouts/:tab' exact/>

                <Route component={GamesScreen} path='/admin/games' exact/>
                <Route component={GamesScreen} path='/admin/games/:tab' exact/>
                <Route component={GameScreen} path='/admin/game/:id' exact />
                <Route component={GameScreen} path='/admin/game/:id/:tab' exact />

                <Route component={CategoryScreen} path='/admin/categories/:id' exact />
                <Route component={AdScreen} path='/ads/:type/:id/:tab/:proId' exact />
                
                <Route component={ProsScreen} path='/admin/pros' exact />
                <Route component={ProScreen} path='/admin/pro/:id' exact />
                <Route component={ProScreen} path='/admin/pro/:id/:tab' exact />
                
                <Route component={PartnersScreen} path='/admin/partners' exact />
                <Route component={PartnerScreen} path='/admin/partner/:id' exact />
                <Route component={StatsScreen} path='/admin/stats' exact />            
                <Route component={StatsScreen} path='/admin/stats/:tab' exact />            
                <Route component={NotifsScreen} path='/admin/notifs' exact />
                <Route component={NotifScreen} path='/admin/notif' exact />
                <Route component={AdminsScreen} path='/admin/admins/' exact />
                <Route component={AdminScreen} path='/admin/admin/:id' exact />
                <Route component={MapScreen} path='/admin/map' exact />
                <Route component={TestAccountsScreen} path='/admin/test/accounts' exact />
              </React.Fragment>
            )}
          </div>
        )}
        <MessengerCustomerChat
          appId="756591474776473"
          pageId="1267463816714812"
          //loggedInGreeting="Réponse dans la journée"
          //loggedOutGreeting="N'hésitez pas à nous soliciter si vous avez un quelconque soucis ou une interrogation"
          language="fr_FR"
        />
        <PopupContainer />
      </Router>
    );
  }
}


const mapStateToProps = (state: any) => ({
  user: state.authReducer.user,
})
const mapDispatchToProps = (dispatch: any) => ({
  autologin: (user: any) => dispatch(autologin(user)),
  finishLogin: () => dispatch(finishLogin()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Routing)
